import { __assign } from 'tslib';

var fontFamilies = {
    body: "DM Sans, sans-serif",
    heading: "DM Sans, sans-serif",
    monospace: "monospace, monospace",
};
var fontWeights = {
    body: 400,
    medium: 500,
    heading: 700,
    bold: 700,
};
var googleWebFontFamilies = ["DM Sans:400,500,700"];
var letterSpacings = [0, 0.5];
var fontSizes = {
    0: "0.625rem",
    1: "0.75rem",
    2: "0.875rem",
    3: "1.0rem",
    4: "1.125rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2.0rem",
    9: "2.5rem",
};
fontSizes.body = fontSizes[3];
fontSizes.title = fontSizes[3];
fontSizes.xxs = fontSizes[0];
fontSizes.xs = fontSizes[1];
fontSizes.sm = fontSizes[2];
fontSizes.md = fontSizes[3];
fontSizes.lg = fontSizes[4];
fontSizes.xl = fontSizes[5];
fontSizes.xxl = fontSizes[6];
fontSizes.xxxl = fontSizes[8];
fontSizes.h6 = fontSizes[3];
fontSizes.h5 = fontSizes[5];
fontSizes.h4 = fontSizes[6];
fontSizes.h3 = fontSizes[7];
fontSizes.h2 = fontSizes[8];
fontSizes.h1 = fontSizes[9];
fontSizes.buttonXs = fontSizes[1];
fontSizes.buttonSm = fontSizes[2];
fontSizes.buttonMd = fontSizes[3];
fontSizes.buttonLg = fontSizes[3];
fontSizes.iconXs = fontSizes[3];
fontSizes.iconSm = fontSizes[5];
fontSizes.iconMd = fontSizes[6];
fontSizes.iconLg = fontSizes[7];
var body = {
    fontFamily: "body",
    fontSize: "md",
    fontWeight: "body",
    lineHeight: 4,
    margin: 0,
    padding: 0,
    verticalAlign: "baseline",
};
var heading = __assign(__assign({}, body), { fontWeight: "bold" });
var fonts = {
    body: body,
    title: __assign(__assign({}, body), { fontWeight: "bold" }),
    xxxl: __assign(__assign({}, body), { fontSize: "xxxl", lineHeight: 3 }),
    xxl: __assign(__assign({}, body), { fontSize: "xxl", lineHeight: 3 }),
    xl: __assign(__assign({}, body), { fontSize: "xl", lineHeight: 2 }),
    lg: __assign(__assign({}, body), { fontSize: "lg" }),
    md: __assign(__assign({}, body), { fontSize: "md" }),
    sm: __assign(__assign({}, body), { fontSize: "sm" }),
    xs: __assign(__assign({}, body), { fontSize: "xs" }),
    xxs: __assign(__assign({}, body), { fontSize: "xxs" }),
    h1: __assign(__assign({}, heading), { fontSize: "h1", lineHeight: 2 }),
    h2: __assign(__assign({}, heading), { fontSize: "h2", lineHeight: 2 }),
    h3: __assign(__assign({}, heading), { fontSize: "h3", lineHeight: 2 }),
    h4: __assign(__assign({}, heading), { fontSize: "h4", lineHeight: 2 }),
    h5: __assign(__assign({}, heading), { fontSize: "h5" }),
    h6: __assign(__assign({}, heading), { fontSize: "h6" }),
};
// https://every-layout.dev/rudiments/modular-scale/
// 0.666 =  0.444 * 1.5
// 1     =  0.666 * 1.5
// 1.5   =  1 * 1.5
// 2.25  =  1.5 * 1.5
// 3.375 =  2.25 * 1.5
// 5.0625 = 3.375 * 1.5
var lineHeights = [0, 1, 1.2, 1.4, 1.5];

export { fontFamilies, fontSizes, fontWeights, fonts, googleWebFontFamilies, letterSpacings, lineHeights };
//# sourceMappingURL=typography.js.map
